import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { SelectPicker } from 'rsuite';

import InputWrapper from './InputWrapper';

export const HookFormSelectPicker = ({
  name,
  defaultValue = '',
  required = false,
  label = '',
  isHidden = false,
  largeLabel = false,
  disabled = false,
  data = [],
  boldLabel = false,
  ...rest
}) => {
  const { setValue, register, formState, watch, unregister } = useFormContext();
  const value = watch(name, defaultValue);
  const error = formState?.errors?.[name];

  const onChange = (value) => {
    setValue(name, value, { shouldValidate: true });
  };

  useEffect(() => {
    register(name, {
      required,
    });

    return () => unregister(name);
  }, [register]);

  useEffect(() => {
    setValue(name, defaultValue);
  }, [defaultValue]);

  return (
    <InputWrapper
    isHidden={isHidden}
    label={label}
    errorMessage={error?.message}
    largeLabel={largeLabel}
    boldLabel={boldLabel}
    >
      <SelectPicker
        onChange={onChange}
        value={value}
        disabled={disabled}
        data={data}
        searchable={false}
        placement="autoVerticalStart"
        {...rest}
      />
    </InputWrapper>
  );
};

HookFormSelectPicker.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.arrayOf(PropTypes.string),
  required: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  label: PropTypes.string,
  largeLabel: PropTypes.bool,
  boldLabel: PropTypes.bool,
};

export default HookFormSelectPicker;



// WEBPACK FOOTER //
// ./src/components/HookFormInputs/HookFormSelectPicker.jsx